import { render, staticRenderFns } from "./NewSalary.vue?vue&type=template&id=b331822a&scoped=true&"
import script from "./NewSalary.vue?vue&type=script&lang=js&"
export * from "./NewSalary.vue?vue&type=script&lang=js&"
import style0 from "./NewSalary.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NewSalary.vue?vue&type=style&index=1&id=b331822a&scoped=true&lang=css&"
import style2 from "../../constant/css/detail.css?vue&type=style&index=2&id=b331822a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b331822a",
  null
  
)

export default component.exports